module.exports = __webpack_public_path__ + "img/img27.25278f25.png";